module.exports = __webpack_public_path__ + "img/11.e1c75a8a.jpg";